import { useApp } from "@/store/AppStore";
import { computeKpis } from "@/utils/kpi";
import { formatCOP, formatNumber, monthLabel } from "@/utils/format";
import KpiCard from "@/pages/admin/dashboard/components/KpiCard";

const KpiGrid = () => {
  const { data } = useApp();
  const kpi = computeKpis(data, data.period);
  const periodLabel = `${monthLabel(data.period.month)} ${data.period.year}`;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      <KpiCard
        tone="primary"
        icon="ri-line-chart-line"
        label={`Ventas Totales del Período · ${periodLabel}`}
        value={formatCOP(kpi.totalSales)}
        hint={`${kpi.salesCount} operaciones registradas`}
      />
      <KpiCard
        tone="accent"
        icon="ri-hand-coin-line"
        label="Ganancia Real del Período"
        value={formatCOP(kpi.grossProfit)}
        hint="Precio cobrado por canal − costo base del producto"
      />
      <KpiCard
        tone="secondary"
        icon="ri-award-line"
        label={`Puntos Amway del Período (PV) · ${periodLabel}`}
        value={`${formatNumber(kpi.totalPv)} PV`}
        badge={`Nivel ${kpi.level.label}`}
        progress={kpi.level.progress}
        hint={
          kpi.level.nextPct
            ? `Faltan ${formatNumber(Math.max(0, (kpi.level.nextMinPv ?? 0) - kpi.totalPv))} PV para ${kpi.level.nextPct}%`
            : "Nivel máximo de calificación alcanzado (21%)"
        }
      >
        <div className="mt-3 grid grid-cols-2 gap-2">
          <div className="rounded-md bg-background-200/40 border border-background-300/40 px-2.5 py-2">
            <p className="text-[10px] text-foreground-500">PV por compras de stock</p>
            <p className="text-xs font-bold text-foreground-950">
              {formatNumber(kpi.stockPv)} PV
            </p>
          </div>
          <div className="rounded-md bg-accent-500/15 border border-accent-500/30 px-2.5 py-2">
            <p className="text-[10px] text-foreground-500">Puntos de referidos</p>
            <p className="text-xs font-bold text-accent-200">{formatNumber(kpi.referralPv)} PV</p>
          </div>
        </div>
      </KpiCard>
      <KpiCard
        tone="primary"
        icon="ri-archive-2-line"
        label="Valoración Inventario General (PVP)"
        value={formatCOP(kpi.inventoryTotal)}
        hint="Suma de todo el stock a precio público"
      />
      <KpiCard
        tone="accent"
        icon="ri-pie-chart-2-line"
        label="Base Capital Inventario vs. Ganancia"
        value={formatCOP(kpi.baseCapital)}
        hint={`Capital 75% · Ganancia estimada ${formatCOP(kpi.estimatedProfit)}`}
        progress={75}
      />
      <KpiCard
        tone="secondary"
        icon="ri-wallet-3-line"
        label="Cartera Pendiente por Cobrar"
        value={formatCOP(kpi.receivablePending)}
        hint={`${data.receivables.length} fiados abiertos`}
      />
    </div>
  );
};

export default KpiGrid;